import cn from "classnames";
import styles from "./embeddedVideoSourceIcon.module.scss";

import VidyardIcon from "../../images/brands/vidyard.svg?react";
import VimeoIcon from "../../images/brands/vimeo.svg?react";
import WistiaIcon from "../../images/brands/wistia.svg?react";
import YouTubeIcon from "../../images/brands/youtube.svg?react";

import { EmbeddedVideoSource } from "features/Library/EmbeddedVideos/types/models";

export interface Props {
  className?: string;
  source: EmbeddedVideoSource;
}

const EmbeddedVideoSourceIcon: React.FC<Props> = ({ className, source }): React.ReactElement => {
  const getIcon = (className?: string) => {
    switch (source) {
      case EmbeddedVideoSource.YouTube:
        return <YouTubeIcon className={cn(styles.brandsIcon, className)} />;
      case EmbeddedVideoSource.Vimeo:
        return <VimeoIcon className={cn(styles.brandsIcon, className)} />;
      case EmbeddedVideoSource.Wistia:
        return <WistiaIcon className={cn(styles.brandsIcon, className)} />;
      case EmbeddedVideoSource.Vidyard:
        return <VidyardIcon className={cn(styles.brandsIcon, className)} />;
      default:
        return null;
    }
  };

  return <div className={styles.videoSourceIcon}>{getIcon(className)}</div>;
};

export default EmbeddedVideoSourceIcon;
